import { render, staticRenderFns } from "./BindTable.vue?vue&type=template&id=a9ddab9a&scoped=true&"
import script from "./BindTable.vue?vue&type=script&lang=js&"
export * from "./BindTable.vue?vue&type=script&lang=js&"
import style0 from "./BindTable.vue?vue&type=style&index=0&id=a9ddab9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ddab9a",
  null
  
)

export default component.exports